import Vue from 'vue'
import Router from 'vue-router'
import routers from './router';
import Utils from '../libs/utils';
import { checkCanPath } from '../libs/utils';
import {
  getUser
} from '@/api/login.api';
import {
  getToken,
  setUserInfo,
  setMenu
} from '@/libs/storage';
import store from '../store/index.js';

Vue.use(Router);

// 路由配置
const RouterConfig = {
  mode: 'hash',
  routes: routers
};

export const router = new Router(RouterConfig);

router.beforeEach(async(to, from, next) => {

  // 判断404
  if (to.matched.length === 0) {
    next('/404');
    return;
  }

  // 重新获取用户信息和权限
  if (to.path != '/login' && to.path != '/404' && to.path != '/403') {
    await getUser().then((res) => {
      if (res.code == '0') {
        // 保存用户 保存权限 菜单
        store.commit('SET_USERINFO', res.data || {});
        store.commit('SET_MENULIST', res.data.permissions || []);
      }
    });

    // 判断403
    let permissions = store.getters.menuList;
    let canPath = checkCanPath(to.path, JSON.parse(JSON.stringify(permissions)));
    if(to.path == '/welcome' || to.path == '/index') {
      let canPathReport = checkCanPath('/report_forms', JSON.parse(JSON.stringify(permissions)));
      if(canPathReport) {
        store.commit('SET_OPERATES', canPathReport.operates);
        next('/report_forms');
        return;
      }
    } else if(!canPath){
      next('/403');
      return;
    } else {
      // canPath
      store.commit('SET_OPERATES', canPath.operates);
    }
  }
  // Utils.title(to.meta.title);
  next();
});

router.afterEach((to, form) => {})



// WEBPACK FOOTER //
// ./src/router/index.js